import "core-js/modules/es6.function.name.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import ExpenseCategory from 'src/store/models/ExpenseCategory';
import { dialog } from 'src/boot/mixins.js';
import { colorUtils } from 'src/mixins/colors-utils';
import { cloneDeep } from 'lodash';
export default {
  mixins: [dialog, colorUtils],
  props: ['expense-category', 'onComplete'],
  data: function data() {
    return {
      loading: false,
      isDirty: false,
      errors: {
        name: false,
        unit_price: false,
        unit_name: false
      },
      title: !this.expenseCategory ? this.$t('general.create_new_expense_category') : this.$t('components.expenseCategoryDialog.edit_expense_name', {
        expense_name: this.expenseCategory.name
      }),
      localCategory: !this.expenseCategory ? {
        name: '',
        color: '',
        uses_unit_price: 0,
        unit_name: '',
        unit_price: null
      } : cloneDeep(this.expenseCategory)
    };
  },
  watch: {
    localCategory: {
      deep: true,
      handler: function handler(val, oldVal) {
        if (!this.isDirty && oldVal && this.expenseCategory) {
          this.isDirty = true;
        }
      }
    }
  },
  components: {
    TeDialog: TeDialog
  },
  methods: {
    initData: function initData() {
      if (!this.expenseCategory) {
        this.localCategory.color = this.getRandomColor();
      }
    },
    validate: function validate() {
      var validData = true;

      if (!this.localCategory.name) {
        this.errors.name = true;
      }

      if (this.localCategory.uses_unit_price) {
        if (!this.localCategory.unit_name) {
          this.errors.unit_name = true;
        }

        if (!this.localCategory.unit_price) {
          this.errors.unit_price = true;
        }
      } else {
        this.errors.unit_name = false;
        this.errors.unit_price = false;
      }

      Object.values(this.errors).forEach(function (err) {
        if (err === true) {
          validData = false;
        }
      });
      return validData;
    },
    saveCategory: function saveCategory() {
      var _this = this;

      if (!this.validate()) {
        return;
      }

      this.loading = true;
      this.showLoading();

      if (!this.localCategory.uses_unit_price) {
        delete this.localCategory.unit_price;
        delete this.localCategory.unit_name;
      }

      if (!this.expenseCategory) {
        ExpenseCategory.api().post('/expense-categories/', this.localCategory).then(function (result) {
          _this.$root.$emit('refresh-expenses');

          _this.$q.notify({
            message: _this.$t('components.expenseCategoryDialog.expense_category_created'),
            type: 'positive'
          });

          _this.onOKClick(result.response.data);
        }).finally(function () {
          _this.loading = false;

          _this.hideLoading();
        });
      } else {
        ExpenseCategory.api().put('/expense-categories/' + this.expenseCategory.expense_category_id, this.localCategory).then(function (response) {
          _this.$root.$emit('refresh-expenses');

          _this.$q.notify({
            message: _this.$t('general.has_been_updated', {
              el: _this.expenseCategory.name
            }),
            type: 'positive'
          });

          _this.hide();
        }).finally(function () {
          _this.loading = false;

          _this.hideLoading();
        });
      }
    }
  },
  mounted: function mounted() {
    this.initData();
  }
};